import { Route } from '@angular/router';
import { AppConfig } from './models/config/app-config.type';

export const getAppRoutes = (environment: AppConfig): Route[] => [
  {
    path: '',
    loadChildren: () =>
      import('@self-fix/shell').then((module) =>
        module.getSmartFixRoutes(environment)
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('@error/shell').then((module) => module.ERROR_SHELL_ROUTES),
  },
];
